import React from "react"
import { appTools, cn } from "lib/utils"



export default function Label({ 
  required=false, 
  className,
  children, 
  ...rest
}:{ 
  required?:boolean; 
  className?:string; 
  children:React.ReactNode; 
  [key:string]:any 
}){

  return (
    <label className={cn("text text-sm flex justify-start items-start pl-2 pb-[1.2rem] h-5", className)} {...rest}>
      { children }
    </label>
  )
}